export const capitalize = ([firstLetter, ...restLetters]: string) =>
  [firstLetter?.toLocaleUpperCase(), ...restLetters].join('');
